// features/dashboard/dashboardSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchData',
  async (filters) => {
    const { days, orderStatus, paymentStatus } = filters;
    const response = await axios.get(
      `${apiUrl}/stats/?Days=${days}&OrderStatus=${orderStatus}&PaymentStatus=${paymentStatus}`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        }
      }
    );
    return response.data;
  }
);

const initialState = {
  stats: {
    totalUsers: 0,
    totalSiteBalance: 0,
    totalProfit: 0,
    completedOrders: 0,
    totalAgentBalances: 0,
    popularProducts: [],
    topUsers: [],
    newUsers: [],
    lastDeposits: [],
    agentBalances: [],
    twilioBalance: 0,
    filteredOrders: [],
  },
  filters: {
    days: 30,
    orderStatus: 'pending',
    paymentStatus: 'initial'
  },
  loading: false,
  error: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = {
          totalUsers: action.payload.total_users,
          totalSiteBalance: action.payload.total_site_balance,
          totalProfit: action.payload.total_profit,
          completedOrders: action.payload.completed_orders,
          totalAgentBalances: action.payload.total_agent_balances,
          popularProducts: action.payload.popular_products,
          topUsers: action.payload.top_users,
          newUsers: action.payload.new_users,
          lastDeposits: action.payload.last_deposits,
          agentBalances: action.payload.agent_balances,
          twilioBalance: action.payload.twilio_user_balance,
          filteredOrders: action.payload.filtered_orders,
        };
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { setFilters } = dashboardSlice.actions;
export default dashboardSlice.reducer;